import React from 'react';
import PropTypes from 'prop-types';
import { List, Subheader, Divider, Paper } from 'material-ui';
import Loading from '../../common/Loading/Loading';
import Error from '../../common/Error/Error';
import Comment from '../Comment/Comment';
import style from '../../../styles/styles';
import withTranslation from '../../../hoc/withTranslation';

class CommentList extends React.Component {

    static propTypes = {
        user: PropTypes.object.isRequired,
        title: PropTypes.string,
        handleRejectComment: PropTypes.func,
        handleAcceptComment: PropTypes.func,
        handleDeleteComment: PropTypes.func,
    };

    static defaultProps = {
        loading: false,
        comments: [],
    };

    // Render

    render() {
        const { loading, comments, title, user } = this.props;

        let content;

        if (loading) {
            content = <Loading paper={false} />;
        } else if (comments.length === 0) {
            content =
                <Error
                    title={this.props.t('generic.no_data')}
                    subtitle={this.props.t('generic.add_some_element')}
                />;
        } else {
            content = comments.map((comment, index) => {
                return (
                    <div key={comment.id}>
                        <Comment
                            zDepth={0}
                            user={user}
                            comment={comment}
                            handleRejectComment={this.props.handleRejectComment}
                            handleAcceptComment={this.props.handleAcceptComment}
                            handleDeleteComment={this.props.handleDeleteComment}
                        />
                        {index !== (comments.length - 1) && <Divider inset={false} />}
                    </div>
                );
            });
        }

        return (
            <div>
                <Paper>
                    <List>
                        <Subheader style={style.subHeader}>
                            {title}
                        </Subheader>
                        {content}
                    </List>
                </Paper>
            </div>
        );
    }
}

export default withTranslation(CommentList);



// WEBPACK FOOTER //
// src/components/comment/CommentList/CommentList.js